SmTypeaheadComponent = require './sm-typeahead'

module.exports = App.SmLocationPickerComponent = SmTypeaheadComponent.extend [
    Em.I18n.TranslateableAttributes,
    Em.I18n.TranslateableProperties
]...,
  classNames        : [ 'sm-location-picker' ]
  classNameBindings : ['isLoading', 'isOpen']
  # todo i18n
  # placeholder       : Em.i18n.t 'restaurants.edit.placeholder'
  displayKey        : 'address'
  async             : true
  provider          : 'dadata'
  minLength         : 4
  isLoading         : false
  isOpen            : false
  session: Em.inject.service()
  env: Em.inject.service('environment')
  yandexMapsService: Em.inject.service('yandexMaps')
  dadataService: Em.inject.service('dadata')

  _initializeTypeahead: ->
    minLength = @get 'minLength'
    highlight = @get 'highlight'
    displayKey = @get 'displayKey'
    city  = @get 'city'
    async  = @get 'async'

    provider = @get 'provider'
    if provider == 'google'
      element = @element
      component = @
      autocomplete = new google.maps.places.Autocomplete(element, {})
      autocomplete.addListener 'place_changed', ->
        place = autocomplete.getPlace()
        component.set 'value', element.value
        if (place.geometry && place.geometry.location)
          component.set 'lat', place.geometry.location.lat()
          component.set 'lng', place.geometry.location.lng()

    if provider in ['yandex', 'dadata']
      @$().typeahead(
          minLength: minLength
          highlight: highlight
      ,
          display: displayKey
          # в самом тайпэхеде есть глюк, нужно чтобы этот лимит был больше
          # длины возвращаемой коллекции как минимум вдвое, иначе ничего не выводится
          limit: 20
          async: async
          source: (q, cb, asyncCb) =>
            return if @get('skipGeocode')
            provider = @get 'provider'  
            Ember.run.bind @, @["#{provider}ProviderDebounced"](q, cb, asyncCb)
          templates:
            suggestion: (obj) ->
              # city  = obj.city
              # city = if city? then ", #{city}" else ""

              "<div>#{obj.address}</div>"
      ).on('typeahead:selected typeahead:autocompleted', (e, obj, dataSet) =>
        @setProperties({
          selection: obj,
          value: obj[@get 'displayKey']
          block: obj.block,
          street: obj.street,
          street_type: obj.street_type,
          house: obj.house
        })

      ).on('typeahead:asyncrequest', =>
        return if @get('skipGeocode')
        @set 'isLoading', true
      ).on('typeahead:asynccancel typeahead:asyncreceive', =>
        return if @get('skipGeocode')
        @set 'isLoading', false
      ).on('typeahead:open', =>
        return if @get('skipGeocode')
        @set 'isOpen', true
      ).on('typeahead:close', =>
        return if @get('skipGeocode')
        @set 'isOpen', false
      )

    return

  # Провайдеры могут быть разные. Обязательно нужно
  # реализовывать метод вида yandexProvider в котором просходит запрос и формирование массива данных

  # Запрос к сервису геогодинга, формирование массив элементов, каждый состоящий
  # из 3 полей: address, lat, lng
  yandexProviderDebounced: (q, cb, asyncCb) ->
    Em.run.debounce @, @yandexProvider, q, cb, asyncCb, 1000, false

  yandexProvider: (q, cb, asyncCb) ->
    city  = @get 'city'
    async  = @get 'async'

    city = if Ember.isEmpty(city) then "" else "#{city}, "

    @get('session.currentUser').stat('Yandex','suggest')
    @get('yandexMapsService').retrieve()
      .then (ymaps) =>
        ymaps.suggest("#{city}#{q}").then (raw_items) =>
          items = raw_items.map (e) ->
            {
              address: e.displayName
            }
          if async
            asyncCb(items)
          else
            cb(items)


    # Em.$.getJSON("https://geocode-maps.yandex.ru/1.x/?apikey=#{@get('session.yandex_token')}&format=json&geocode=#{city}#{q}").then (data) =>
    #   dataToSend = data.response.GeoObjectCollection.featureMember.map (item) ->
    #     point = item.GeoObject.Point.pos.split ' '
    #     city = item.GeoObject.description # .split(',')[0]
    #     kind = item.GeoObject?.metaDataProperty?.GeocoderMetaData?.kind

    #     {
    #       address: item.GeoObject.name
    #       lat: point[1]
    #       lng: point[0]
    #       city: city
    #       houseNumberError: (kind != 'house')
    #     }

      # В зависимости от того, синхронный запрос или нет, вызывается соответствующий колбек
      # if async
      #   asyncCb(dataToSend)
      # else
      #   cb(dataToSend)
  
  dadataProviderDebounced: (q, cb, asyncCb) ->
    Em.run.debounce @, @dadataProvider, q, cb, asyncCb, 1000, false

  dadataProvider: (q, cb, asyncCb) ->
    city  = @get('city')
    async  = @get('async')
    address = if Ember.isEmpty(city) then "#{q}" else "#{city}, #{q}"

    @get('dadataService').getSuggestions(address).then (data)=>
      items = data.suggestions.map (el) ->
        {
          address: el.full_address,
          block: el.block, 
          house: el.house, 
          street: el.street, 
          street_type: el.street_type
        }
      if async
        asyncCb(items)
      else
        cb(items)

  change: (args...) ->
    @_super(args)
    @sendAction 'onChange', @get 'value', @get 'lat', @get 'lng'
